import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Popper } from '../../primitives/Popper/Popper.es.js';
import { Fade } from '../Fade/Fade.es.js';
import { Container } from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var Component = function Component(_a) {
  var _b = _a,
      children = _b.children,
      _b$hasArrow = _b.hasArrow,
      hasArrow = _b$hasArrow === void 0 ? false : _b$hasArrow,
      _b$isOpen = _b.isOpen,
      isOpen = _b$isOpen === void 0 ? false : _b$isOpen,
      onClose = _b.onClose,
      onOpen = _b.onOpen,
      _b$placement = _b.placement,
      placement = _b$placement === void 0 ? "bottom" : _b$placement,
      _b$offset = _b.offset,
      offset = _b$offset === void 0 ? [0, 16] : _b$offset,
      anchorRef = _b.anchorRef,
      triggerRef = _b.triggerRef,
      _b$size = _b.size,
      size = _b$size === void 0 ? "auto" : _b$size,
      disablePortal = _b.disablePortal,
      _b$usePortal = _b.usePortal,
      usePortal = _b$usePortal === void 0 ? true : _b$usePortal,
      onClickOutside = _b.onClickOutside,
      isLazy = _b.isLazy,
      _b$zIndex = _b.zIndex,
      zIndex = _b$zIndex === void 0 ? 1e3 : _b$zIndex,
      props = __objRest(_b, ["children", "hasArrow", "isOpen", "onClose", "onOpen", "placement", "offset", "anchorRef", "triggerRef", "size", "disablePortal", "usePortal", "onClickOutside", "isLazy", "zIndex"]);

  return (
    /* @__PURE__ */
    React.createElement(Popper, {
      onClose: onClose,
      onOpen: onOpen,
      isOpen: isOpen,
      anchorRef: anchorRef,
      triggerRef: triggerRef,
      transitionComponent: Fade,
      popperOptions: {
        placement: placement,
        modifiers: [{
          name: "offset",
          options: {
            offset: offset
          }
        }]
      },
      disablePortal: disablePortal,
      usePortal: usePortal,
      onClickOutside: onClickOutside,
      zIndex: zIndex,
      isLazy: isLazy
    },
    /* @__PURE__ */
    React.createElement(Container, __spreadValues({
      role: "dialog",
      size: size
    }, props), children, hasArrow &&
    /* @__PURE__ */
    React.createElement(Popper.Arrow, null)))
  );
};

Component.displayName = "PopoverBase";
var PopoverBase = maestroComponent("PopoverBase", Component);
export { PopoverBase };